export default {
    accepted_by: "Ким тарабынан кабыл алынган",
    additional_costs: "Чыгымдар",
    additional_discount_correction: "Кошумча арзандатуу үчүн тууралоо",
    additional_income: "Кошумча киреше",
    admin_statistics_future: "Келерки күндөр үчүн жаңы жазылуулар боюнча администратордун статистикасы",
    administrator_percent: "Администратордун пайызы",
    administrator_sum: "Администратордун суммасы",
    all_visits_of_current_branch_independent_of_status_including_cancelled: "Бул филиалга бардык баруулар, статусуна карабастан, анын ичинде жокко чыгарылды",
    apply: "Колодонуу",
    assistant_percent: "Жардамчынын пайызы",
    assistant_sum: "Жардамчынын суммасы",
    average_cheque: "Орточо чек",
    average_conversion_per_doctor_per_day: "Күнүмдүк дарыгерлердин орточо көрсөткүчү",
    average_conversion_per_doctor_per_period: "Мезгил ичиндеги дарыгерлердин орточо көрсөткүчү",
    average_qty_of_goods_in_cheque: "ПРИЦИАЛДАГЫ ЗАЛДАРДЫН орточо саны",
    balance_amount: "Депозиттен төлөнгөн",
    balance_return: "Депозитти кайтаруу",
    became_permanent: "Туруктуу болуп калды",
    by: "Ким тарабынан",
    by_means: "Төлөө формасы боюнча",
    by_services: "Кызматтар боюнча",
    calculated_from_calendar_visit_duration: "Календардагы жазуулардын узактыгынан эсептелет",
    came_again: "Кайра келди",
    came_among_patients: "Алардын ичинен келишкен",
    came_later_over_total_primary: "Биринчи жолу келгендерден кайталанган коноктордун пайызы",
    cancel_date: "Жокко чыгаруу күнү",
    cancel_reason: "Жокко чыгаруу себеби",
    cancelled_among_them: "Алардын саны жокко чыгарылды",
    cancelled_visits: "Жокко чыгарылган визиттер",
    cash_flow_statement: "Акча каражаттарынын агымы жөнүндө отчет",
    cash_received_report_day_explanation: "Мезгил ичинде түшкөн каражаттар: визиттер үчүн төлөмдөр (депозиттик, бонустук, кепилдик ж.б. сыяктуу төлөмдөрдүн түрлөрүнөн тышкары) жана депозитти толуктоодон/чектөөдөн түшкөн каражаттар",
    cashdesk_report: "Кассалык отчет",
    conversion: "Конверсия",
    conversion_came_to_permanent: "Конверсия (жетилген -> туруктуу)",
    cos: "Өздүк наркы",
    cost_of_attracting_primary_patient: "Негизги бейтапты тартуунун баасы",
    cost_of_materials: "Материалдардын баасы",
    cost_of_visits_for_selected_interval: "Тандалган интервалдын ичинде аяктаган зыяраттардын баасы",
    costs: "Чыгымдар",
    crm_leads_analytics: "CRM өтүнмө аналитикасы",
    curator_id: "Куратордун Id",
    curator_name: "Куратордун аты",
    curator_percent: "Куратордун пайызы",
    curator_sum: "Куратордун суммасы",
    daily_report: "Күнүмдүк отчет",
    debt_payments: "Карыздарды төлөө",
    debt_writeoff: "Карыздарды эсептен чыгаруу",
    debtor: "Карызкор",
    debtors: "Карызкорлор",
    debtors_statement: "Карызкорлор жөнүндө отчет",
    deleted_payments_registry: "Алыстан төлөө реестри",
    deposit_movements: "Депозиттердин кыймылы",
    deposit_reconciliation_report: "Депозиттерди салыштыруу отчету",
    details_by_visits: "Визиттер боюнча деталдар",
    did_not_came_again: "Кайра келген жок",
    did_not_come_among_patients: "Алардын ичинен бири келген жок",
    doctor_load_percent: "Дарыгердин жүктөмүнүн %",
    doctor_name: "Дарыгер",
    doctor_percent: "Дарыгердин пайызы",
    doctor_salary: "Дарыгердин эмгек акысы",
    doctor_statistics: "Дарыгерлер боюнча статистика",
    doctor_sum: "Дарыгердин суммасы",
    doctors_conversion: "Дарыгерлер боюнча конверсия",
    doctors_load: "Дарыгерлердин жүктөмү",
    duration: "Продолжительность",
    export_from: " баштап жүктөө",
    exports: "Жүктөөлөр",
    f057: "057 формасы",
    first_visit_date: "Биринчи визиттин датасы",
    first_visit_doctor: "Биринчи визиттин дарыгери",
    full_name: "Аты",
    general_percent: "Жалпы пайыз",
    have_later_visits_independent_of_interval: "Тандалган интервалга карабастан келечектеги жазуулар бар",
    have_later_visits_within_selected_interval: "Тандалган аралыкта дагы жазуулар бар",
    have_no_later_visits_independent_of_interval: "Тандалган интервалга карабастан, мындан ары жазуулар жок",
    hidden_columns: "Жашырылган колонкалар",
    hide_cancelled_visits: "Жокко чыгарылган визиттерди жашыруу",
    how_much_was_paid_for_visit_for_the_whole_time_independent_of_selected_period: "Тандалган отчеттук интервалга карабастан, бүт убакыт үчүн бир сапар үчүн төлөм",
    in_progress: "Иштетилүүдө",
    includes_both_discount_on_specific_services_and_general_discount: "Белгилүү кызматтарга арзандатууларды жана сапарга жалпы арзандатууну камтыйт",
    including_adjustment_for_general_visit_discount: "жалпы баруу арзандатуу үчүн түзөтүүнү камтыйт",
    including_weighted_average_adjustment_for_general_visit_discount: "Бир барган сайын жалпы арзандатуу үчүн орточо салмактанып алынган тууралоону камтыйт",
    income_by_doctors: "Дарыгерлер боюнча киреше",
    income_by_services: "Кызматтар боюнча киреше",
    initiator: "Демилгечи",
    invoiced: "Эсепти коюу",
    last_visit_date: "Акыркы визиттин датасы",
    last_visit_doctor: "Акыркы визиттин дарыгери",
    last_visit_recommendation: "Акыркы визиттин сунуштары",
    list_of_patients_with_visits_in_this_branch_for_selected_interval: "Тандалган интервал үчүн бул филиалга барган бейтаптардын тизмеси",
    margins: "Дүң киреше",
    materials_movement_analytics: "Материалдык агымдын аналитикасы",
    minutes_visit_was_opened_in_control_system: "Иш сапардын протоколдору «визиттин башталышы жана аяктоосу» контролдоо системасында ачылды",
    next_visit_date: "Кийинки визиттин датасы",
    next_visit_doctor: "Кийинки визиттин дарыгери",
    number_of_patient_visits_for_given_interval: "Тандалган интервал үчүн пациентке баруулардын саны",
    only_fiscal_cheques: "Фискалдык чектер гана",
    only_fiscal_payments: "Фискалдык төлөмдөр гана",
    only_paid: "Төлөнгөн гана",
    operation_type: "Операциянын түрү",
    orthodontist: "Ортодонт",
    orthopedist: "Ортопед",
    paid_for: " үчүн төлөнгөн",
    paid_from_account: "Эсептен төлөндү",
    paid_invoices: "Төлөнгөн эсептер",
    paid_sum: "Төлөмдүн суммасы",
    patient_deposits: "Пациенттин депозиттери",
    patient_id: "Бейтаптын Id",
    patient_name: "Бейтап",
    patient_source: "Пациент булагы",
    patient_status: "Бейтаптын статусу",
    patients_conversion: "Пациенттин конверсиясы",
    payments_registry: "Төлөм реестри",
    payments_within_interval_for_visits_happened_within_interval: "Тандалган интервалда болгон сапарлар үчүн гана тандалган интервал үчүн төлөмдөрдүн суммасы",
    payments_within_interval_for_visits_happened_within_interval_excluding_refunds: "Тандалган интервалда аткарылган сапарлар үчүн гана тандалган интервал үчүн төлөмдөрдүн суммасы (төлөм кайтарылбайт)",
    pdf_report: "PDF отчет",
    permanent_among_patients: "Алардын ичинен үзгүлтүксүз бейтаптар менен визиттер",
    pl_statement: "Кирешелер жана чыгымдар жөнүндө отчет",
    plan_treatment_complexes: "Комплекстер",
    plan_treatments: "Дарылоо планы",
    previous_visit_date: "Мурунку визиттин датасы",
    price_before_discount: "Арзандатууга чейинки сумма",
    primary: "Биринчи",
    primary_among_patients: "Алардын ичинен биринчи бейтаптар менен визиттер",
    primary_marketing_expenses: "Негизги маркетинг чыгымдары",
    primary_records: "Биринчи - жазылган",
    primary_records_came: "Биринчи - жеткирилген",
    primary_records_cancelled: "Баштапкы - жокко чыгарылды",
    primary_records_did_not_come: "Биринчи - жеткирилген эмес",
    primary_records_further: "Биринчи - кийинки жазылган",
    primary_records_revenue: "Биринчи - киреше",
    product_name: "Продукциянын аты",
    recorded_later: "Кайра жазылды",
    records: "Визиттер",
    records_count: "Визиттердин саны",
    refunds_within_interval: "Тандалган интервал үчүн төлөм кайтарылат",
    repeated: "Кайталанган",
    repeated_records: "Кайталанган - жазылган",
    repeated_records_came: "Кайталанган - жеткирилген",
    repeated_records_cancelled: "Кайталап - жокко чыгарылды",
    repeated_records_did_not_come: "Кайталанган - жеткирилген эмес",
    repeated_records_further: "Кайталанган - кийинки жазылган",
    repeated_records_revenue: "Кайталанган - киреше",
    report_days_limit: "Отчеттуулук мезгилин (күндөрдү) чектөө",
    report_is_too_heavy_confirm: "Отчетту баракта көрүү үчүн өтө чоң, excel файл файлына жүктөш керекпи?",
    revenue: "Киреше",
    revenue_per_hour: "Саатына карата киреше",
    revenues: "Киреше",
    revenues_report_day_explanation: "Бардык жолдор менен тандалган мезгил үчүн визиттер үчүн төлөмдөр, кошумча киреше (бухгалтердик эсепке алуу) жана товарларды сатуудан түшкөн каражаттар",
    salary_report: "Эмгек акы боюнча отчет",
    saldo: "Сальдо",
    sale_date: "Сатылган күнү",
    sales_funnel_applications: "Воронка: Өтүнмөлөр - Кайрылуулар",
    sales_funnel_plans: "Воронка: Дарылоо пландары",
    see_all: "Баарын көрүү",
    see_only_yourself: "Өзүңдү гана көрүү",
    services_amount: "Кызматтардын саны",
    show_block_as_free_time: "Блокторду бош убакыт катары саноо",
    show_completed_visits: "Жеткен визиттерди көрсөтүү",
    show_deleted: "Өчүрүлгөндөрдү көрсөтүү",
    show_deleted_doctors: "Өчүрүлгөн дарыгерлерди көрсөтүү",
    show_only_new_patients: "Жаңы бейтаптарды гана көрсөтүү",
    source_of_patient_acquisition: "Оорулууларды тартуунун баштапкы булагы",
    source_of_visit_acquisition: "Түзүү булагына баш багыңыз",
    source_type: "Булак түрү",
    technic_percent: "Техниктин пайызы",
    technic_sum: "Техниктин суммасы",
    therapist: "Терапевт",
    total_acquiring_deductions: "Эквайринг боюнча жалпы чегерүү",
    total_cost_of_services: "Кызматтардын жалпы наркы",
    total_materials_deductions: "Материалдар боюнча жалпы чегерүү",
    total_patients: "Жазылган бейтаптардын саны",
    total_payments: "Бардык төлөмдөр",
    total_primary: "Биринчилердин бардыгы",
    total_primary_patients_records: "Баштапкы бейтаптардын жалпы жазуулары",
    total_revenue: "Бардык киреше",
    total_salary: "Бардык эмгек акы",
    total_technic_laboratory_deductions: "Техник / лабораториялык чегерүүнүн жыйынтыгы",
    total_unique_primary_patients: "Бардык уникалдуу негизги бейтаптар",
    total_with_deductions: "Чегерүүлөр менен сумма",
    unique_patients_recorded_during_selected_report_interval: "Тандалган отчет интервалында жазылган уникалдуу пациенттердин саны",
    unique_patients_with_first_visit_for_interval: "Тандалган интервалдын ичинде алгачкы сапары менен уникалдуу бейтаптар",
    unpaid_invoices: "Төлөнбөгөн эсептер",
    updated_date: "Өзгөртүү датасы",
    visit_id: "Жазылуунун Id",
    visit_price_including_all_discounts: "Бардык арзандатууларды эске алуу менен баруунун баасы",
    visit_statistics: "Сизиттердин статистикасы",
    visits_by_source: "Булактар боюнча визиттер",
    visits_cost_over_services_count: "Кызматтардын санына келүүлөрдүн баасы",
    visits_detailed: "Визиттер (кеңейтилген)",
    visits_of_current_branch_which_has_services_or_has_status_other_than_not_come: "Кызматтары бар же \"келбеди\" дегенден башка статусу бар бул филиалга баруулар",
    visits_of_current_branch_which_have_services_or_have_status_came: "Кызматтар менен баруулар же \"оорулуу келди\" статусу",
    visits_price_including_all_discounts: "Бардык арзандатууларды кошкондо зыяраттардын баасы",
    where_came_from: "Кайдан келди",
    who_cancelled: "Ким жокко чыгарды",
    who_changed_status: "Статусту ким өзгөрттү (Төлөм / Келди)",
    who_created: "Ким тарабынан түзүлгөн",
    who_updated: "Ким өзгөрттү",
    with_patient: "Бейтап менен",
    worked_days: "Иштетилген күндөр",
    worked_hours: "Иштетилген сааттар",
    your_report_is_processing: "Отчетуңуз түзүлүүдө. Ал даяр болгондо эскертме аласыз"
}
